import React, { useEffect, useState } from 'react';
import CookieConsent, { Cookies } from 'react-cookie-consent';
import { updateConsentState, checkExistingConsent } from '../utils/analytics';

const CookieConsentBanner = () => {
  const [hasConsent, setHasConsent] = useState(false);
  
  useEffect(() => {
    // Check for existing consent on component mount
    const checkConsent = async () => {
      const consentState = await checkExistingConsent();
      setHasConsent(consentState.analytics === 'granted');
    };
    
    checkConsent();
  }, []);

  const handleAccept = () => {
    updateConsentState('analytics', true);
    setHasConsent(true);
  };

  const handleDecline = () => {
    updateConsentState('analytics', false);
    setHasConsent(false);
  };

  // If user already consented, don't show the banner
  if (hasConsent) {
    return null;
  }

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      enableDeclineButton
      onAccept={handleAccept}
      onDecline={handleDecline}
      style={{ background: '#2B373B' }}
      buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
      expires={150} // Cookie expires after 150 days
    >
      This website uses cookies to enhance the user experience and to analyze site traffic. 
      We use Google Analytics to collect anonymous information about how you use our website.
      {" "}
      <a href="/privacy-policy" style={{ textDecoration: 'underline' }}>
        Learn more in our Privacy Policy
      </a>
    </CookieConsent>
  );
};

export default CookieConsentBanner;